exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uk-modal .uk-modal-header h3[data-v-840000dc] {\n  font-size: 24px;\n  font-family: Arial,Tahoma,sans-serif !important;\n  color: #444;\n  margin: 0;\n  padding: 0;\n}\n.uk-modal .uk-modal-header i[data-v-840000dc] {\n  margin-right: 7px;\n}\n.uk-modal .uk-modal-footer[data-v-840000dc] {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 30px;\n  height: 70px;\n}\n.uk-modal .uk-modal-footer .footer-content[data-v-840000dc] {\n    display: flex;\n}\n.uk-modal .uk-modal-footer .print-block .uk-button[data-v-840000dc] {\n    margin: 0 2px;\n}\n", ""]);

// exports
